<!--
 * @Description  : 提示卡片
-->
<template>
  <order-common-card
    title="{{title}}"
    sideTitle="{{sideTitle}}"
    sideIcon="{{sideIcon}}"
    sideColor="{{sideColor}}"
    bind:sideClick="onSideClick"
  >
    <view class="tips" wx:for="{{formatTips}}" wx:key="index">
      <view
        wx:class="{{ {'tips-item':true, highlight:tip.highlight} }}"
        wx:for="{{item}}"
        wx:for-item="tip"
      >{{tip.value}}</view>
    </view>
  </order-common-card>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  import { filterHighlightText } from '@/common/public'

  createComponent({
    props: {
      title: {
        type: String,
        value: ''
      },
      sideTitle: {
        type: String,
        value: ''
      },
      sideIcon: {
        type: Boolean,
        value: false
      },
      sideColor: {
        type: String,
        value: ''
      },
      texts: {
        type: Array,
        value: () => ([])
      }
    },
    computed: {
      formatTips() {
        return this.texts.map(str => filterHighlightText(str))
      }
    },
    methods: {
      onSideClick() {
        this.$trigger('sideClick', null)
      }
    }
  })
</script>

<style scoped lang="stylus" src="./style.styl"></style>

<script name="json">
  module.exports = {
    component: true,
    usingComponents: {
      'order-common-card': '../order-common-card',
    }
  }
</script>